import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2499880a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { class: "box mark" }
const _hoisted_5 = { class: "high-light" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "厅台毛利排行榜", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: { background: '#E5F6F4', fontWeight: 500 }
}, [
  /*#__PURE__*/_createElementVNode("div", null, "厅台名称"),
  /*#__PURE__*/_createElementVNode("div", null, "总毛利"),
  /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "毛利率")
], -1))
const _hoisted_9 = { class: "mark" }
const _hoisted_10 = { class: "percentage" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "店员销售排行", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row mark",
  style: { background: '#E5F6F4', fontWeight: 500 }
}, [
  /*#__PURE__*/_createElementVNode("div", { style: {
                  width: '130px',
                } }, " 店员姓名 "),
  /*#__PURE__*/_createElementVNode("div", { style: {
                  width: '130px',
                } }, " 所属厅台 "),
  /*#__PURE__*/_createElementVNode("div", null, "总销量"),
  /*#__PURE__*/_createElementVNode("div", null, "总毛利"),
  /*#__PURE__*/_createElementVNode("div", { class: "percentage" }, "毛利率")
], -1))
const _hoisted_13 = { class: "mark" }
const _hoisted_14 = { style: {
                    width: '130px',
                  } }
const _hoisted_15 = { style: {
                    width: '130px',
                  } }

import { ref, watch, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import { CellGroup, Cell, Tabs, Tab, Overlay, Loading, Empty } from "vant";
import { formatPercentage, numToMoney } from "@/utils";
import createWatermark from "@/utils/watermark";
import dayjs from "dayjs";

import request from "@/provide/fetch";


export default /*#__PURE__*/_defineComponent({
  __name: 'BusinessHallHB',
  setup(__props) {

const route = useRoute();
const active = ref(0);

const visible = ref(false);
const pageData = ref<any>({});
let time = dayjs(route?.params.time as string).format("YYYY-MM-DD");
const getPageData = async () => {
  const res = await request({
    url: "/api/wx/bh/hb/summary",
    method: "POST",
    data: {
      startDay: time,
      endDay: time,
      provinceName: "河北",
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    pageData.value = res.data;
    visible.value = true;
    console.log(pageData.value);
  } else {
    // showFailToast(res.data);
  }
};
getPageData();

// 选择区域
const businessHallList = ref<any[]>([]);
const getBusinessHallList = async () => {
  const res = await request({
    url: "/api/wx/bh/hb/hall-sale-person/detail",
    method: "POST",
    data: {
      pageParam: {
        current: 1,
        size: 200,
      },
      searchOption: {
        startDay: time,
        endDay: time,
        province: "河北",
        statisticColumn: "businessHall",
        orderItem: {
          field: "grossProfit",
          asc: false,
        },
        salePerson: true,
        // groupUnit: sessionStorage.getItem("openid"),
      },
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  distributorLoading.value = false;
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    businessHallList.value = res.data.records;
  } else {
    // showFailToast(res.data);
  }
};
getBusinessHallList();
// 店员排行
const distributorLoading = ref(false);
const sellerList = ref<any>([]);
const getSellerList = async () => {
  distributorLoading.value = true;
  const res = await request({
    url: "/api/wx/bh/hb/hall-sale-person/detail",
    method: "POST",
    data: {
      pageParam: {
        current: 1,
        size: 200,
      },
      searchOption: {
        startDay: time,
        endDay: time,
        province: "河北",
        statisticColumn: "salesMan",
        orderItem: {
          field: "grossProfit",
          asc: false,
        },
        salePerson: true,
        // groupUnit: sessionStorage.getItem("openid"),
      },
    },
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  distributorLoading.value = false;
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    sellerList.value = res.data.records;
  } else {
    // showFailToast(res.data);
  }
};
getSellerList();

const getUserInfo = async () => {
  return request({
    url: "/api/wx/user/getUserByOpenId",
    method: "GET",
    params: {
      openId: sessionStorage.getItem("openid"),
    },
  }).then((res) => {
    if (res.code === 200) {
      sessionStorage.setItem("name", res.data.name);
    }
  });
};
const activeItem = ref(0);
onMounted(() => {
  if (sessionStorage.getItem("name")) {
    createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
  } else {
    getUserInfo().then(() => {
      createWatermark(sessionStorage.getItem("name"), "mark", "#fff");
    });
  }
});

const tabs = ref();
watch(visible, () => {
  nextTick(() => {
    tabs.value.resize();
  });
});
const handlePercentage = (item: any) => {
  const noformat = ['当日分期总量', '新增号卡总量','宽带业务总量', '手机销售总量', '智能组网销售总量'] 
  if (noformat.includes(item.name)) {
    return item.value
  } else {
    return item.type === "percentage"
      ? formatPercentage(item.value)
      : numToMoney(item.value);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(_unref(dayjs)(_unref(route).params.time as string).format("YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(CellGroup), null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value, (item, index) => {
              return (_openBlock(), _createBlock(_unref(Cell), {
                title: item.name,
                size: index < 3 ? 'large' : 'normal',
                class: _normalizeClass(index < 3 ? 'bold' : ''),
                "title-style": { width: '120px', flex: 'inherit' },
                border: index !== 3,
                key: index
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, [
                    _createTextVNode(_toDisplayString(handlePercentage(item)) + "（环比：", 1),
                    _createElementVNode("span", {
                      style: _normalizeStyle({ color: item.percentage >= 0 ? 'red' : 'green' })
                    }, _toDisplayString(`${item.percentage >= 0 ? "+" : ""}${_unref(formatPercentage)(
                      item.percentage
                    )}`), 5),
                    _createTextVNode("） ")
                  ])
                ]),
                _: 2
              }, 1032, ["title", "size", "class", "border"]))
            }), 128))
          ]),
          _: 1
        }),
        _hoisted_6,
        _createVNode(_unref(Tabs), {
          active: active.value,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
          ref_key: "tabs",
          ref: tabs
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Tab), { title: "厅台维度" }, {
              default: _withCtx(() => [
                _hoisted_7,
                _hoisted_8,
                (!businessHallList.value?.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 0,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(businessHallList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row",
                      style: { borderBottom: '1px solid #ebedf0' },
                      key: index
                    }, [
                      _createElementVNode("div", null, _toDisplayString(item.businessHall), 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(numToMoney)(item.grossProfit)), 1),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(item.totalProfitPercentage), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Tab), { title: "店员维度" }, {
              default: _withCtx(() => [
                _hoisted_11,
                _hoisted_12,
                (!sellerList.value.length)
                  ? (_openBlock(), _createBlock(_unref(Empty), {
                      key: 0,
                      description: "暂无数据",
                      "image-size": "100"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sellerList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(item.sellerName), 1),
                      _createElementVNode("div", _hoisted_15, _toDisplayString(item.businessHall), 1),
                      _createElementVNode("div", null, _toDisplayString(item.orderCount), 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(numToMoney)(item.grossProfit)), 1),
                      _createElementVNode("div", null, _toDisplayString(item.totalProfitPercentage), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["active"])
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})